import domainManagementService from 'services/domainManagementService';

const apiDomain = domainManagementService.getApiDomain();

const API_DOMAIN = apiDomain;
export default API_DOMAIN;

export const ERROR_CODE = {
  START_DATE_INVALID: 'StartDateInValid',
};

export const API = {
  FILE: 'files',
};

export const CODE_API = {
  getCodeValue: {
    name: (codeName) => `getCodeValue/${codeName}`,
    path: (codeName) => `/voucher-discount/code/${codeName}`,
  },
};
